import React from 'react';
import ManagementPage from './ManagementPage';
export default function FinancialAccountsPage() { return <ManagementPage resource="accounts" />; }
